import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
import { ymd } from '../../../utils/date';
import { PAYMENTS_PATH, TRANSACTIONS_PATH, PAYMENTS_MULTISIGNATORY_PATH } from './constant';
import { PAYMENT_TYPE } from '../../../screens/payments/constant';
import Guid from '../../../utils/guid';
import { pipeSummary } from './parser'
import envConfig from '../../../../db-env-build';
import {API_RESPONSE_CODES, EBANKINGWEBUK, RM_REGION_UK} from '../../../constants';
import moment from 'moment';
import { Base64 } from 'js-base64';
import isValidJsonString from '../../../utils/is-valid-json-string';



export default () => muster()
  .path('payments.fetchTx', {
    call: async ({ req }, { get, set, call }) => {
      const { orderId, paymentTypeDesc } = req.args[0];
      let { paymentType } = req.args[0];
      const isInternal = paymentType.includes('internal')
      set('payments.paymentType', paymentType);
      set('payments.isFetchingTx', true);
      set('payments.initializeTxFails', false)
      set('payments.errorMsgs', '')
      set('payments.errorMsgFlag', false)
      const channel = 'WEB'
      const deviceCode = ''
      paymentType = (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && paymentType.includes(PAYMENT_TYPE.domestic) ? PAYMENT_TYPE.domesticuk : paymentType;
      
      const inputs = `${paymentType}#@#${orderId}#@#${deviceCode}#@#${channel}`;
      const [result] = await getValues(get(`${TRANSACTIONS_PATH}.fetchTx["${inputs}"]["${Guid()}"]`));
      const [messages] = await getValues(get('i18n.messages'));
      let data
      // console.log('----------muster', JSON.parse(result))
      try { data = JSON.parse(result) }
      catch (e) {
        set('payments.initializeTxFails', true)
        set('payments.isFetchingTx', false);
        return;
      }
      const isAvaloqAvailable = data ? data.backEndAvailable : false
      if (!isAvaloqAvailable) {
        const message = data.message // Failed to connect to payment service
        set('payments.initializeTxFails', message);
        set('payments.isFetchingTx', false);
        return;
      }
      const chargeDesc = (data && data.costDetails && data.costDetails.ebLabelDesc) || ''
      const currentTx = pipeSummary({ paymentType, data, txToken: data.txToken, chargeDesc, type: 'fetchTx' })
      const defaultCost = data.costList && data.costList.find(e => e.costType === 'SHA')
      const modifyTxt = messages['app.payment.pageTitle.modifyTxt'];
      const paymentTxt = messages['app.payment.pageTitle.paymentTxt'];
      let exOrderId = '';
      if (data.externalOrderId != null) {
        exOrderId = data.externalOrderId;
      }
      if(data.paymentReasonList) {
        const paymentReasonList = data.paymentReasonList || [];
        set('payments.paymentReasonList', paymentReasonList);
      }

      const modifyTitle = modifyTxt + ' ' + paymentTypeDesc + ' ' + exOrderId;
      set('payments.isFetchingTx', false);
      set('payments.initializeTxFails', false)
      console.log('----------muster data', data)
      set('payments.transactionId', data.transactionId ? data.transactionId : '')
      set('payments.tppName', data.tppName ? data.tppName : '')
      set('payments.currentTx', currentTx)
      set('payments.debtAcList', data.cashAccountList)
      set('payments.creditAcList', data.cashAccountList)
      set('payments.beneficiaryList', data.beneficiaryList)
      set('payments.curcyWhiteList', data.currencyList)
      set('payments.costList', data.costList)
      set('payments.startDate', ymd(data.executionDate))
      set('payments.selectedCurrency', data.currency)
      set('payments.selectedCost', data.costDetails || defaultCost)
      set('payments.amount', data.amount)
      set('payments.sortCode', data.sortCode)

      set('payments.remarks', data.remarks && data.remarks.replaceAll('\n', '') || '');
      set('payments.paymentReason', data.payReasonKey || '');


      // let remarks = data.remarks;

      // if(remarks && remarks != '') {              //WMCE-49249-To resolve data integrity error issue on modification of pending payment in CH and LUX
      //   let sliceIndex = remarks.indexOf('-');
      //   if(sliceIndex > 0) {
      //     let remarksArray = [remarks.slice(0,sliceIndex), remarks.slice(sliceIndex+1)];
      //     set('payments.remarks', remarksArray[1].replaceAll('\n', ''));          
      //     set('payments.paymentReason', remarksArray[0]);
      //   } else {
      //     set('payments.remarks', remarks);
      //     // set('payments.paymentReason', '');
      //   }
      // } else {
      //   set('payments.remarks', '');
      //   set('payments.paymentReason', '');
      // }



      set('payments.selectedDebitAcnt', data.cashAccountDetails)
      if (isInternal) {
        set('payments.selectedCreditAcnt', data.creditAccountDetails)
      } else {
        // Fix for WMCE-12458 Beneficiary id missing (we need to consume userBeneficiaryId here)
        const beneficiaryDet = data.beneficiaryDetails;
        beneficiaryDet.sortCode = data.sortCode;
        beneficiaryDet.beneficiaryId = beneficiaryDet.userBeneficiaryId;
        set('payments.selectedBeneficiaryBank', beneficiaryDet)
      }
      set('payments.businessDateIniTx', data.businessUnitBankDate)
      set('payments.txToken', data.txToken)
      set('payments.txRef', data.txRef)
      set('payments.orderId', data.id)
      set('payments.versionId', data.versionId)
      set('payments.externalOrderId', data.externalOrderId)
      // todo: dumb logic, fix in future
      set('payments.isModifyFlow', true)
      set('payments.modifyTitle', modifyTitle)
      // todo: end
    }
  })

  //muster path for view payments for multisignatory
  .path('payments.viewPaymentOrder', {
    call: async ({ req }, { get, set, call }) => {
      const { paymentUUID, paymentTypeDesc } = req.args[0];
      let { paymentType } = req.args[0];
      const isInternal = paymentType.includes('internal')
      set('payments.paymentType', paymentType);
      set('payments.multisigUUID', paymentUUID);
      set('payments.isFetchingTx', true);
      set('payments.initializeTxFails', false)
      set('payments.errorMsgs', '')
      set('payments.errorMsgFlag', false)
      const channel = 'WEB'
      const deviceCode = ''


      paymentType = (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && paymentType.includes(PAYMENT_TYPE.domestic) ? PAYMENT_TYPE.domesticuk : paymentType;
      const [langCode] = await getValues(get('auth.langCode'));
      const [userId] = await getValues(get('auth.userId'));
      const request = {
          userId:userId,
          paymentUUID:paymentUUID,
          deviceCode: deviceCode,
          channel: channel,
          language: langCode,
        }
      const requestObj = Base64.encode(JSON.stringify(request));

      // const inputs = `${paymentType}#@#${orderId}#@#${deviceCode}#@#${channel}`;
      const [result] = await getValues(get(`${PAYMENTS_PATH}.viewPaymentOrder["${requestObj}"]["${Guid()}"]`));
      const [messages] = await getValues(get('i18n.messages'));
      let data
      // console.log('----------muster', JSON.parse(result))
      try { data = JSON.parse(result) }
      catch (e) {
        set('payments.initializeTxFails', true)
        set('payments.isFetchingTx', false);
        return;
      }
      const isAvaloqAvailable = data ? data.backEndAvailable : false
      if (!isAvaloqAvailable) {
        const message = data.message // Failed to connect to payment service
        set('payments.initializeTxFails', message);
        set('payments.isFetchingTx', false);
        return;
      }
      const chargeDesc = (data && data.costDetails && data.costDetails.ebLabelDesc) || ''
      const currentTx = pipeSummary({ paymentType, data, txToken: data.txToken, chargeDesc, type: 'txForViewMultisign' })
      const defaultCost = data.costList && data.costList.find(e => e.costType === 'SHA')
      const modifyTxt = messages['app.payment.pageTitle.modifyTxt'];
      const paymentTxt = messages['app.payment.pageTitle.paymentTxt'];
      let exOrderId = '';
      if (data.externalOrderId != null) {
        exOrderId = data.externalOrderId;
      }
      if(data.paymentReasonList) {
        const paymentReasonList = data.paymentReasonList || [];
        set('payments.paymentReasonList', paymentReasonList);
      }

      const modifyTitle = modifyTxt + ' ' + paymentTypeDesc + ' ' + exOrderId;
      set('payments.isFetchingTx', false);
      set('payments.initializeTxFails', false)
      console.log('----------muster data', data)
      set('payments.transactionId', data.transactionId ? data.transactionId : '')
      set('payments.tppName', data.tppName ? data.tppName : '')
      set('payments.currentTx', currentTx)
      set('payments.debtAcList', data.cashAccountList)
      set('payments.creditAcList', data.cashAccountList)
      set('payments.beneficiaryList', data.beneficiaryList)
      set('payments.curcyWhiteList', data.currencyList)
      set('payments.costList', data.costList)
      set('payments.startDate', ymd(data.executionDate))
      set('payments.selectedCurrency', data.currency)
      set('payments.selectedCost', data.costDetails || defaultCost)
      set('payments.amount', data.amount)
      set('payments.sortCode', data.sortCode)
      set('payments.isMultiSigViewOnlyFlow', true)
      set('payments.remarks', data.remarks && data.remarks.replaceAll('\n', '') || '');
      set('payments.paymentReason', data.payReasonKey || '');
      set('payments.isApprovalFlowLockedByUser', data.isLockedByUser || false);



      set('payments.selectedDebitAcnt', data.cashAccountDetails)
      if (isInternal) {
        set('payments.selectedCreditAcnt', data.creditAccountDetails)
      } else {
        // Fix for WMCE-12458 Beneficiary id missing (we need to consume userBeneficiaryId here)
        const beneficiaryDet = data.beneficiaryDetails;
        beneficiaryDet.sortCode = data.sortCode;
        beneficiaryDet.beneficiaryId = beneficiaryDet.userBeneficiaryId;
        set('payments.selectedBeneficiaryBank', beneficiaryDet)
      }
      set('payments.businessDateIniTx', data.businessUnitBankDate)
      set('payments.txToken', data.txToken)
      set('payments.orderId', data.id)
      set('payments.versionId', data.versionId)
      set('payments.externalOrderId', data.externalOrderId)
      // todo: dumb logic, fix in future
      set('payments.isModifyFlow', true)
      set('payments.modifyTitle', modifyTitle)
      // todo: end
    }
  })
  // muster path for multisignatory
  .path('payments.validateMultiSignPayment', {
    call: async ({ req }, { get, set, call }) => {
      const { paymentUUID, paymentTypeDesc } = req.args[0];
      let { paymentType } = req.args[0];
      const isInternal = paymentType.includes('internal')
      set('payments.paymentType', paymentType);
      set('payments.isFetchingTx', true);
      set('payments.initializeTxFails', false)
      set('payments.errorMsgs', '')
      set('payments.errorMsgFlag', false)
      set('payments.orderId', paymentUUID)
      const channel = 'WEB'
      const deviceCode = ''
      paymentType = (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && paymentType.includes(PAYMENT_TYPE.domestic) ? PAYMENT_TYPE.domesticuk : paymentType;
      

      //encode input
       const request = {          
        paymentUUID: paymentUUID,
        deviceCode: deviceCode,
        channel: channel
      }
      const inputs = Base64.encode(JSON.stringify(request));

      // const inputs = `${paymentType}#@#${paymentUUID}#@#${deviceCode}#@#${channel}`;
      const [result] = await getValues(get(`${PAYMENTS_MULTISIGNATORY_PATH}.validateMultisignPayment["${inputs}"]["${Guid()}"]`));
      const [messages] = await getValues(get('i18n.messages'));
      let data
      // console.log('----------muster', JSON.parse(result))
      
      try { data = JSON.parse(result) ;
     
      const currentTx = pipeSummary({ paymentType, data, txToken: data.txToken, type: 'txForMultisign' })
      
      const defaultCost = data.costList && data.costList.find(e => e.costType === 'SHA')
      const modifyTxt = messages['app.payment.pageTitle.modifyTxt'];
      const paymentTxt = messages['app.payment.pageTitle.paymentTxt'];
      let exOrderId = '';
      if (data.externalOrderId != null) {
        exOrderId = data.externalOrderId;
      }
      if(data.paymentReasonList) {
        const paymentReasonList = data.paymentReasonList || [];
        set('payments.paymentReasonList', paymentReasonList);
      }
      if (data.dwoMessage.messages) {
        // blocking errors
        const error = data.dwoMessage.messages
        set('payments.errorMsgs', error)
        set('payments.errorMsgFlag', true)

      }

      const modifyTitle = modifyTxt + ' ' + paymentTypeDesc + ' ' + exOrderId;
      set('payments.isFetchingTx', false);
      set('payments.isMultiSigApprovalFlow', true)
      set('payments.initializeTxFails', false)
      console.log('----------muster data', data)
      set('payments.transactionId', data.transactionId ? data.transactionId : '')
      set('payments.tppName', data.tppName ? data.tppName : '')
      set('payments.currentTx', currentTx)
      set('payments.debtAcList', data.cashAccountList)
      set('payments.beneficiaryList', data.beneficiaryList)
      set('payments.curcyWhiteList', data.currencyList)
      set('payments.costList', data.costList)
      set('payments.startDate', moment(data.executionDate).format('yyyy-MM-dd'))
      set('payments.selectedCurrency', data.currency)
      set('payments.selectedCost', data.costDetails || defaultCost)
      set('payments.amount', data.amount)
      set('payments.sortCode', data.sortCode)
      set('payments.disableTabs', true);

      set('payments.remarks', data.remarks && data.remarks.replaceAll('\n', '') || '');
      set('payments.paymentReason', data.payReasonKey || '');




      // set('payments.selectedDebitAcnt', data.cashAccountDetails)
      // if (isInternal) {
      //   set('payments.selectedCreditAcnt', data.creditAccountDetails)
      // } else {
      //   // Fix for WMCE-12458 Beneficiary id missing (we need to consume userBeneficiaryId here)
      //   const beneficiaryDet = data.beneficiaryDetails;
      //   beneficiaryDet.beneficiaryId = beneficiaryDet.userBeneficiaryId;
      //   set('payments.selectedBeneficiaryBank', beneficiaryDet)
      // }
      // set('payments.businessDateIniTx', data.businessUnitBankDate)
      set('payments.txToken', data.txToken)
      
      // set('payments.orderId', data.uuid)
      set('payments.versionId', data.versionId)
      set('payments.externalOrderId', data.externalOrderId)
      // todo: dumb logic, fix in future
      set('payments.isModifyFlow', true)
      set('payments.modifyTitle', modifyTitle)
      // todo: end

    } catch (e) { 
      console.log('Error in validateMultiSignPayment', e);
        set('payments.initializeTxFails', true)
        set('payments.isFetchingTx', false);
        return;
      }
    }
  })

  .path('payments.cancelTx', {
    call: async ({ req }, { get, set }) => {
      await set('payments.loading', true);
      const channel = 'WEB';
      const deviceCode = ''
      const rand = Math.floor(Math.random() * 1000000)
      const [paymentType, { orderId = rand, txToken, versionId = 1 }] = await getValues(get(['payments.paymentType', 'payments.currentTx']));
      //APT txToken
      const input = `${paymentType}#@#${orderId}#@#${channel}#@#${deviceCode}#@#${versionId}`;
      // const input = `${paymentType}#@#${orderId}#@#${channel}#@#${deviceCode}#@#${versionId}#@#${txToken}`;
      const [result] = await getValues(get(`${TRANSACTIONS_PATH}.cancelTx["${input}"]["${Guid()}"]`));

        //handle errors WILL TAKE IT UP POST DEMO
      // isValidJsonString(result).then(async (data) => {
      //   set('payments.loading', false)
      //   if(data && data.returnCode.toString() === API_RESPONSE_CODES.SUCCESS) {
      //     //no action to do
      //   }else if (data && data.errorCode) {
      //     await Promise.all[(
      //       set('payments.errorMsg', data.message)
      //     )]
      //   } 
      // }).catch(async (error) => {
      //    await Promise.all[(
      //       set('payments.errorMsg', messages['app.payments.failToConnect'])
      //     )]
      // });
    }
  })

  .path('payments.resumeMultisignPayment', {
    call: async ({ req }, { get, set, call }) => {
      // const { paymentUUID, paymentTypeDesc } = req.args[0];
      let [paymentType] = await getValues(get('payments.paymentType'));
      let [paymentUUID] = await getValues(get('payments.multisigUUID'));

      const isInternal = paymentType.includes('internal')

      // set('payments.paymentType', paymentType);
      set('payments.isFetchingTx', true);
      set('payments.initializeTxFails', false)
      set('payments.errorMsgs', '')
      set('payments.errorMsgFlag', false)
      set('payments.orderId', paymentUUID)
      const channel = 'WEB'
      const deviceCode = ''
      paymentType = (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && paymentType.includes(PAYMENT_TYPE.domestic) ? PAYMENT_TYPE.domesticuk : paymentType;
      

      //encode input
       const request = {          
        paymentUUID: paymentUUID,
        deviceCode: deviceCode,
        channel: channel
      }
      const inputs = Base64.encode(JSON.stringify(request));

      // const inputs = `${paymentType}#@#${paymentUUID}#@#${deviceCode}#@#${channel}`;
      const [result] = await getValues(get(`${PAYMENTS_MULTISIGNATORY_PATH}.resumeMultisignPayment["${inputs}"]["${Guid()}"]`));
      const [messages] = await getValues(get('i18n.messages'));
      let data
      // console.log('----------muster', JSON.parse(result))
      
      try { data = JSON.parse(result) ;
     
      const currentTx = pipeSummary({ paymentType, data, txToken: data.txToken, type: 'txForMultisign' })
      
      const defaultCost = data.costList && data.costList.find(e => e.costType === 'SHA')
      const modifyTxt = messages['app.payment.pageTitle.modifyTxt'];
      const paymentTxt = messages['app.payment.pageTitle.paymentTxt'];
      let exOrderId = '';
      if (data.externalOrderId != null) {
        exOrderId = data.externalOrderId;
      }
      if(data.paymentReasonList) {
        const paymentReasonList = data.paymentReasonList || [];
        set('payments.paymentReasonList', paymentReasonList);
      }
      if (data.dwoMessage.messages) {
        // blocking errors
        const error = data.dwoMessage.messages
        set('payments.errorMsgs', error)
        set('payments.errorMsgFlag', true)

      }

      // const modifyTitle = modifyTxt + ' ' + paymentTypeDesc + ' ' + exOrderId;
      set('payments.isFetchingTx', false);
      set('payments.initializeTxFails', false)
      console.log('----------muster data', data)
      set('payments.transactionId', data.transactionId ? data.transactionId : '')
      set('payments.tppName', data.tppName ? data.tppName : '')
      set('payments.currentTx', currentTx)
      set('payments.debtAcList', data.cashAccountList)
      set('payments.beneficiaryList', data.beneficiaryList)
      set('payments.curcyWhiteList', data.currencyList)
      set('payments.costList', data.costList)
      set('payments.startDate', moment(data.executionDate).format('yyyy-MM-dd'))
      set('payments.selectedCurrency', data.currency)
      set('payments.selectedCost', data.costDetails || defaultCost)
      set('payments.amount', data.amount)
      set('payments.sortCode', data.sortCode)
      set('payments.disableTabs', true);

      set('payments.remarks', data.remarks && data.remarks.replaceAll('\n', '') || '');
      set('payments.paymentReason', data.payReasonKey || '');
      await set('payments.isMultiSigApprovalFlow', true);
      await set('payments.isMultiSigViewOnlyFlow', false);
      await set('payments.isApprovalFlowLockedByUser', false);




      // set('payments.selectedDebitAcnt', data.cashAccountDetails)
      // if (isInternal) {
      //   set('payments.selectedCreditAcnt', data.creditAccountDetails)
      // } else {
      //   // Fix for WMCE-12458 Beneficiary id missing (we need to consume userBeneficiaryId here)
      //   const beneficiaryDet = data.beneficiaryDetails;
      //   beneficiaryDet.beneficiaryId = beneficiaryDet.userBeneficiaryId;
      //   set('payments.selectedBeneficiaryBank', beneficiaryDet)
      // }
      // set('payments.businessDateIniTx', data.businessUnitBankDate)
      set('payments.txToken', data.txToken)
            set('payments.versionId', data.versionId)
      set('payments.externalOrderId', data.externalOrderId)
      // todo: dumb logic, fix in future
      set('payments.isModifyFlow', true)
      // set('payments.modifyTitle', modifyTitle)
      // todo: end

    } catch (e) { 
      console.log('Error in validateMultiSignPayment', e);
        set('payments.initializeTxFails', true)
        set('payments.isFetchingTx', false);
        return;
      }
    }
  })

  .path('payments.rejectTx', {
    call: async ({ req }, { get,set }) => {     
      await set('payments.loading', true);
      const [messages] = await getValues(get('i18n.messages')); 
      const channel = 'WEB';
      const rejectReason = req.args[0] || '';
      
      const [paymentType, uuid] = await getValues(get(['payments.paymentType', 'payments.orderId']));
      const request = {
        txType: paymentType,
        channel: channel,
        paymentUUID :uuid,
        rejectionReason:rejectReason
        }

      const requestObj = Base64.encode(JSON.stringify(request));

      // const input = `${paymentType}#@#${channel}#@#${deviceCode}#@#${uuid}#@#${rejectReason}`;
      const [result] = await getValues(get(`${TRANSACTIONS_PATH}.rejectTx["${requestObj}"]["${Guid()}"]`));

      //handle errors
      isValidJsonString(result).then(async (data) => {
        set('payments.loading', false)

        if(data && data.returnCode.toString() === API_RESPONSE_CODES.SUCCESS) {
          await set('payments.isRejectApiSuccess', true);

        } else if (data && data.errorCode) {
          await Promise.all[(
            set('payments.errorMsgs',data.dwoMessage.messages)
          )]
        }
      }).catch(async (error) => {
         await Promise.all[(
            set('payments.initializeTxFails', true)
          )]
      });
    }
  })
  .path('payments.getPaymentStatus', {
    call: async ({ req }, { get, set, call }) => {
      await set('payments.paymentRefresh.showSpinner', true);
      const [result] = await getValues(get(`${TRANSACTIONS_PATH}.txRefresh["${Guid()}"]`));
      let status = {}
      try {
        status = JSON.parse(result)
      } catch (e) {
        // when timeout, get FATAL error, treat as cancelled
        status = { transState: 'cancelled', validTime: true }
      }
      await set('payments.paymentRefresh.showSpinner', false);
      await set('payments.refreshStatus', status)
    }
  })
  .path('payments.currentTx', variable({}))
  .path('payments.modifyTitle', variable(''))
  .path('payments.refreshStatus', variable({}))
  .path('payments.isFetchingTx', variable(false))
  .path('payments.orderId', variable())
  .path('payments.multisigUUID', variable())
  .path('payments.versionId', variable())
  .path('payments.externalOrderId', variable())
  .path('payments.paymentRefresh.showSpinner', variable(false))
  .path('payments.transactionId', variable())
  .path('payments.tppName', variable())
  .path('payments.isMultiSigApprovalFlow', variable(false))
  .path('payments.isMultiSigViewOnlyFlow', variable(false))
  .path('payments.isRejectApiSuccess', variable(false))
  .path('payments.isApprovalFlowLockedByUser', variable(false))
  .path('payments.sortCode', variable())
